export default __webpack_public_path__ + "static/media/Remove.fd554c99.svg";